import React, { ReactElement } from 'react'
import Link from 'next/link'

import { Article } from '@telesoft/lib/web/constants/types'
import Grid from '../grid'
import Button from '../ui/button'
import ResourceItem from '../resource-item'
import ResourceItemLoader from '../ui/loaders/resource-feed-loader'

interface Props {
  isLoading?: boolean
  isError?: boolean
  error?: any
  data: any
}

export default function ResourceGridSection({
  isLoading = false,
  isError = false,
  error,
  data,
}: Props): ReactElement {
  if (isError) console.log(error)
  return (
    <Grid>
      {isLoading && <ResourceItemLoader />}

      {!isLoading &&
        data &&
        data?.length > 0 &&
        data.map((resource: Article) => {
          return <ResourceItem key={`resource--key${resource.id}`} resource={resource} />
        })}

      {!isLoading && data?.length === 0 && (
        <div className="bg-accent-1 col-span-full flex w-full items-center justify-center p-6 md:p-8 lg:p-10">
          <div className="flex flex-col items-start justify-center">
            <h4>
              No resources found matching this filter. Please select another and try again. Go back?
            </h4>

            <Link passHref href={`/blog`} legacyBehavior>
              <Button variant="cta" className="mt-8">
                Go back
              </Button>
            </Link>
          </div>
        </div>
      )}

      {!isLoading && isError && (
        <div className="bg-accent-1 col-span-full flex w-full items-center justify-center py-10">
          <div className="flex flex-col items-start justify-center">
            <h4>500: Issue collecting articles for this category.</h4>

            <Link passHref href={`/blog`} legacyBehavior>
              <Button variant="cta" className="mt-8">
                Go back
              </Button>
            </Link>
          </div>
        </div>
      )}
    </Grid>
  )
}
